<template>
  <div style="display: block">
    <PeriodPickerMonths
      v-show="!showYears"
      v-bind="$props"
      :focused-year="focusedYear"
      :highlighted-period="highlightedPeriod"
      :new-layout="newLayout"
      @period-click="openPeriod"
      @year-click="yearClick"
    />
    <PeriodPickerYears
      v-show="showYears"
      :years="years"
      :highlighted-year="highlightedYear"
      :new-layout="newLayout"
      @year-click="openYear"
      @header-click="openFocusedYear"
    />
  </div>
</template>

<script>
import PeriodPickerMonths from './period-picker-months'
import PeriodPickerYears from './period-picker-years'

const PeriodPickerYearsWithPeriods = {
  components: {
    PeriodPickerMonths,
    PeriodPickerYears,
  },
  props: {
    highlightedYear: {
      type: Object,
      default: () => ({}),
    },
    highlightedPeriod: {
      type: Object,
      default: () => ({}),
    },
    years: {
      type: Array,
      required: true,
    },
    ledgersPerYear: {
      type: Number,
      default: 12,
    },
    currentLedgerId: {
      type: Number,
      default: null,
    },
    newLayout: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['period-click'],
  data() {
    return {
      focusedYear: this.resolveFocusedYear(),
      showYears: false,
    }
  },
  methods: {
    resolveFocusedYear() {
      if (this.highlightedYear && Object.keys(this.highlightedYear).length) {
        return this.highlightedYear
      }

      const selectableYears = this.years.filter((year) =>
        year.periods.some((period) => period.ledgerId)
      )

      return selectableYears[selectableYears.length - 1] || this.years[0]
    },
    yearClick() {
      this.showYears = true
    },
    openYear({ year }) {
      this.focusedYear = year
      this.showYears = false
    },
    openFocusedYear() {
      if (this.focusedYear) {
        this.showYears = false
      }
    },
    openPeriod(period) {
      this.$emit('period-click', { period })
    },
  },
}

export default PeriodPickerYearsWithPeriods
</script>
